import React from 'react'
import { SidebarLink } from './'

export default function LicensesSidebar (props) {
  return (
    <div>
      <SidebarLink 
        name='District Licenses'
        link='/users/licenses/districts'
      />
      <SidebarLink
        name='School Licenses'
        link='/users/licenses/schools'
      />
      <SidebarLink
        name='District Admin Licenses'
        link='/users/licenses/district-admins'
      />
      <SidebarLink
        name='Educator Licenses'
        link='/users/licenses/educators'
      />
      <SidebarLink
        name='Student Licenses'
        link='/users/licenses/students'
      />
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/Licenses/LicensesSidebar.js